/**
 * Збій лінивого чанка (`vite:preloadError`) до старту перевірки нової версії (UX-31). Перевірка з
 * банером — лінивий чанк після межі першого екрана (`version.ts`, `shell/GlobalBanners.tsx`, #1244),
 * а реліз, що прибрав файли старої збірки, поки вкладка стартувала (слабкий ПК, до
 * `FIRST_SCREEN_CAP_MS`), інакше лишив би вкладку без банера: слухача ще не було. Тут — лише
 * прапорець першого екрана, перевіряє `watchVersion`, щойно прийшов чанк.
 */
let failed = false;

/** Старт вкладки (`main.tsx`): запам'ятати перший збій чанка. */
export function noteChunkError(): void {
  window.addEventListener(
    'vite:preloadError',
    () => {
      failed = true;
    },
    { once: true },
  );
}

/** Чи не завантажився хоч один чанк з початку вкладки. */
export const chunkFailed = (): boolean => failed;

/** Лише для тестів: збою не було. */
export function resetChunkErrorForTests(): void {
  failed = false;
}
